/**
 * Audit log reducer.
 * @module reducers/auditLog/auditLog
 */

import { GET_AUDIT_LOG, RESET_AUDIT_LOG } from '../../constants/ActionTypes';

const initialState = {
  error: null,
  items: [],
  loaded: false,
  loading: false,
  total: 0,
  b_size: 25,
  b_start: 0,
};

/**
 * Audit log reducer.
 * @function auditLog
 * @param {Object} state Current state.
 * @param {Object} action Action to be handled.
 * @returns {Object} New state.
 */
export default function auditLog(state = initialState, action = {}) {
  switch (action.type) {
    case `${GET_AUDIT_LOG}_PENDING`:
      return {
        ...state,
        error: null,
        loaded: false,
        loading: true,
      };
    case `${GET_AUDIT_LOG}_SUCCESS`:
      return {
        ...state,
        error: null,
        items: action.result.items,
        total: action.result.total,
        b_size: action.result.b_size,
        b_start: action.result.b_start,
        loaded: true,
        loading: false,
      };
    case `${GET_AUDIT_LOG}_FAIL`:
      return {
        ...state,
        error: action.error,
        items: [],
        total: 0,
        loaded: false,
        loading: false,
      };
    case RESET_AUDIT_LOG:
      return initialState;
    default:
      return state;
  }
}
